module.exports = __webpack_public_path__ + "static/media/dashboard_menu_icon.3209c3a3.svg";